import { createSlice } from "@reduxjs/toolkit";
const initialState ={
    account:null,
    name:"",
    email:"",
    phonenumber:"",
    selected_date:"",
    selected_car:"",
    selected_tour:"",
};
const userSlice= createSlice({
    name:"user",
    initialState ,
    reducers:{
        setUser:(state,action)=>{
               state.account=action.payload
        },
        setSelectedCar:(state,action)=>{
            state.selected_car=action.payload
        }
    }
});
export const {setUser,setSelectedCar}=userSlice.actions;
export default userSlice.reducer